import React, { createContext, useContext } from "react";

import noop from "lodash/noop";

const Context = createContext({
  allUntracked: false,
  historyContext: "todo",
  sortDir: "desc",
  openDateFilterPickerModal: noop,
  dateFilter: {
    options: []
  },
});

Context.displayName = "History.Context";

export default Context;

export function useHistoryContext() {
  return useContext(Context);
}



// WEBPACK FOOTER //
// ./app/components/History/Context.jsx